<template>
    <div>
        <template v-if="payment_preference == true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Subscription Charges </h1>
            </div>
          <div class="global-main">
            <form id="subscriptionFeeForm" @submit.prevent="editSubscriptionFeeData">
              <div class="tab-content-inner">
                <div class="form-group">
                  <label> Company </label>
                  <h2>{{company_name}}</h2>
                  <has-error :form="form" field="companyId"></has-error>
                </div>
                <div class="form-group">
                  <label> IBFT </label>
                  <select v-model="form.ibft" name="ibft" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('ibft') }">
                    <option value="EMONEY" selected>EMONEY</option>
                    <option value="EASYPAISA">EASYPAISA</option>
                    <option value="FINCA">FINCA</option>
                    <option value="MEEZAN">MEEZAN</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
                  <div class="form-group">
                      <label> EPLFT </label>
                      <select v-model="form.eplft" name="ibft" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('eplft') }">
                          <option value="EASYPAISA">EASYPAISA</option>
                          <option value="FINCA">FINCA</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                  </div>
                <div class="form-group">
                  <label> BILL </label>
                  <select v-model="form.bill" name="bill" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('bill') }">
                    <option value="EMONEY" selected>EMONEY</option>
                    <option value="FINCA">FINCA</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
                <div class="form-group">
                  <label> TOPUP </label>
                  <select v-model="form.topup" name="topup" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('topup') }">
                    <option value="EMONEY" selected>EMONEY</option>
                    <option value="FINCA">FINCA</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
                <div class="form-group">
                  <label> Status </label>
                  <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                    <option value="" selected>Select Status</option>
                    <option value="ON">ON</option>
                    <option value="OFF">OFF</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
              </div>
              <div class="form-group">
                <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                <router-link to="/subscriptionFee" class="btn btn-primary float-right mr-2">Cancel</router-link>
              </div>
            </form>
          </div>
        </template>
        <template v-else-if="payment_preference === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="payment_preference === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
          return {
            form: new Form({
              company_id: "",
              ibft: "",
              eplft: "",
              bill: "",
              topup: "",
              status: "",
            }),
            company_name: "",
            payment_preference: null,
          };
        },
        methods: {
          editSubscriptionFeeData() {
                this.$Progress.start();
            Swal.fire({
              title: 'Are you sure?',
              text: 'Payment Preference for selected company will be edited!',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Proceed'
            }).then((result) => {
              if (result.value) {
                this.form
                    .put("/api/updatePaymentPreference")
                    .then((res) => {
                      if (res.status == 200) {
                        if (res.data.code == 200) {
                          this.resetForm();
                          this.$Progress.finish();
                          this.showToastBox("success", "Payment Preference updated successfully");
                          this.$router.push("/paymentPreferenceList");
                        } else {
                          $(this.$el).find('.selectpicker').selectpicker('refresh');
                          this.showToastBox("error", res.data.message);
                        }
                      } else {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox("error", "Some error in your form data");
                      }
                    })
                    .catch((err) => {
                      $(this.$el).find('.selectpicker').selectpicker('refresh');
                      this.$Progress.fail();
                      this.showAlertBox("error", "Some error in your form data");
                    });
              }else{this.$router.go(this.$router.currentRoute);}
            })

            },
            resetForm() {
              this.form.company_id = "";
              this.form.charges = "";
              this.form.status = "";
            },
          getEditPaymentPreferenceData() {
                axios
                    .get("/api/editPaymentPreferenceData/" + this.$route.params.id)
                    .then((res) => {
                        if (res.status == 200) {
                            this.company_name = res.data.company_name;
                            this.form.company_id = res.data.company_id;
                            this.form.ibft = res.data.IBFT;
                            this.form.eplft = res.data.EPLFT;
                            this.form.bill = res.data.BILL;
                            this.form.topup = res.data.TOPUP;
                            this.form.status = res.data.status;
                            this.$Progress.finish();
                            setTimeout(function(){
                            $('.selectpicker').selectpicker('refresh');

                            },0)

                        } else {
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                            this.showAlertBox("error", "error while loading data");
                        }
                    })
                    .catch((err) => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox("error", "error while loading data");
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("payment_preference")
                .then((result) => {
                    this.payment_preference = result.payment_preference;
                })
                .then((result) => {
                    if (this.payment_preference == true) {
                        this.getEditPaymentPreferenceData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                    setTimeout(() => {
                        $('.selectpicker').selectpicker('refresh');
                    }, 1000);
                });
        },
    }
</script>
